<template>
    <div id="luckDrawBox" class="live-dialog-bg" v-if="luckDrawStatus !== 0">
        <div class="luckdraw-container">
            <van-icon class="close-icon" @click="onCloseDialog" name="cross" />
            <div v-show="luckDrawStatus === 1">
                <img src="https://res.peki.vip/20230112/97e4aa18b7e64bb6a3b857eb8c80ceb8.png" />
                <div class="tips-text">开始抽奖</div>
            </div>
            <div v-show="luckDrawStatus === 2">
                <img src="https://res.peki.vip/20230112/046cc345897046f48ef064220367bdc1.gif" />
                <div class="tips-text">抽奖中</div>
            </div>
            <div v-show="luckDrawStatus === 3">
                <img src="https://res.peki.vip/20230112/ab4e48148b90474781d1bbdccdfcf0e6.png" />
                <div class="desc">恭喜中奖者</div>
                <div class="username">{{ userNames }}</div>
            </div>
            <div v-show="luckDrawStatus === 4">
                <img src="https://res.peki.vip/20230112/ab4e48148b90474781d1bbdccdfcf0e6.png" />
                <div class="username current-user">恭喜您，中奖啦！</div>
                <div class="desc">请微信联系群主领取奖励哦</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['luckDrawStatus', 'luckDrawUserName'],
    computed: {
        userNames: function () {
            console.log(this.luckDrawUserName)
            if (this.luckDrawUserName && this.luckDrawUserName.length !== 0) {
                const _list = this.luckDrawUserName.map((i) => i.nickname)
                return _list.join(',')
            }
            return '匿名用户'
        },
    },
    watch: {
        luckDrawStatus: function (status) {
            if (status === 1) {
                setTimeout(() => {
                    this.$emit('closeLuckDraw', 2)
                }, 1000)
            }
        },
    },
    methods: {
        onCloseDialog() {
            this.$emit('closeLuckDraw', 0)
        },
    },
}
</script>

<style lang="scss">
.live-dialog-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #333, $alpha: 0.4);
    z-index: 999;
}
#luckDrawBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .luckdraw-container {
        position: relative;
        background: #fff;
        width: 320px;
        border-radius: 5px;
        box-shadow: 5px 2px 8px rgba($color: #999, $alpha: 0.3);
        padding: 12px 0 20px;
        .close-icon {
            position: absolute;
            top: 12px;
            right: 12px;
            font-size: 20px;
            color: #aaa;
            cursor: pointer;
        }
        img {
            width: 250px;
            margin: 16px auto 6px;
            display: block;
        }
        .tips-text {
            text-align: center;
            font-size: 18px;
            font-weight: 600;
        }
        .username {
            color: crimson;
            font-size: 16px;
            text-align: center;
            margin-top: 12px;
            font-weight: 700;
            line-height: 1.4em;
        }
        .current-user {
            margin: 0 0 12px 0;
        }
        .desc {
            font-size: 14px;
            text-align: center;
        }
    }
}
</style>
